import React from "react";
import Email from './../assets/icons/email.png';
import Phone from './../assets/icons/contact-number.png';

const FooterPage = () =>{

return(
    <div className="background-container" style={{padding:'3%'}}>
      {/* <div style={{display:'flex',marginLeft:'auto',marginRight:'auto'}}> */}
        <div className="row" style={{textAlign:'left',margiRight: '-15px',marginLeft: '60px'}}>
        <div className=" col-lg-5 col-md-12">
          <h3 style={{fontWeight:'normal',fontSize:'50px',color:'#000'}}>
            <small>Get in</small>
            <b>touch</b>
          </h3>
          <p style={{color:'#000'}}>We ignite the fuel! To revamp your business and take it to the next level!</p>
          <span>
            <p></p>
            <h4>
              <b>Our Branches</b>
            </h4>
            <p></p>
            <table style={{width:'100%'}}>
              <tr>
                <td style={{width:'50%'}}>
                  <br />
                  <b>USA</b>
                 <br /> 8837, Whitney Dr,
                 <br /> Lewis center, OH USA 43035,
                 <br />OH 43035
                </td>
              
              
                <td style={{width:'50%'}}>
                  <br />
                  <b>INDIA</b>
                 <br /> 2nd Floor, JQ Chambers
                 <br /> Jayabheri Enclave, 
                 <br />Gachibowli,Hyd
                 <br/>Telangana 500032
                </td>
                </tr>
            </table>
          </span>
        </div>
        <div className="col-lg-7">
          <table style={{textAlign:'center',width:'100%'}}>
            <tbody>
              <tr>
                <td width={{width:'30%'}}>
                  <img src={Phone}/>
                  <p>
                    <small>
                    <a href="tel:+1 6142188735" ><br/>(+1)614 218 8735(USA)</a>
                    <a href="tel:+1 6142188735" ><br/>(+91)970333181(India)</a>
                    </small>
                  </p>
                </td>
                <td width={{width:'30%'}}>
                  <img src={Email}/>
                  <p>
                    <small>
                    <a href="mailto:info@datalake-solutions.com" ><br/>info@datalake-solutions.com</a>
                    </small>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* </div> */}
       
    </div>
      <hr />
    <p class="footer-text  col-lg-12 col-md-12   text-center">
      Copyright © 2023 All rights reserved
    </p>

    </div>
)
};

export default FooterPage;

